import { useEffect, useState } from 'react';

// Vrai dès que l'élément entre dans la zone visible (avec une marge d'avance),
// puis reste vrai : une vignette déjà vue garde sa miniature.
export const useIsVisible = (ref, rootMargin = '200px') => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element || isVisible) return undefined;
    if (typeof IntersectionObserver === 'undefined') {
      setIsVisible(true);
      return undefined;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin }
    );
    observer.observe(element);
    return () => observer.disconnect();
  }, [ref, rootMargin, isVisible]);

  return isVisible;
};
